export default __webpack_public_path__ + "static/media/Desk-Type.fde50477.svg";